import { PropsWithChildren } from "react";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { clientSideID, INITIAL_CONTEXT } from ".";

const PassThrough = ({ children }: PropsWithChildren) => children;

// Without a client ID (fresh clone, tests) the SDK cannot initialize, so the
// app runs unwrapped with every flag at its default instead of blocking.
export const LaunchDarklyProvider = clientSideID
  ? withLDProvider<PropsWithChildren>({
      clientSideID,
      context: INITIAL_CONTEXT,
      // Without a timeout, an unreachable LD holds the loading gate forever;
      // a slow-but-successful init recovers in useLaunchDarkly.
      timeout: 3,
      options: {
        bootstrap: "localStorage",
      },
    })(PassThrough)
  : PassThrough;
